import * as React from 'react';
import { useStyles, useTheme } from '@sravni/react-utils';
import modules_3d0bf2ca from '../styles/ContentWidget.module.less.js';

const generateUrl = (theme, domain) => {
    const origin = typeof window !== 'undefined' ? window.location.origin : undefined;
    try {
        const url = new URL(`/ugc-widgets/news-widget/horizontal/header/${theme}/`, domain || origin);
        return url.toString();
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        console.error(`${domain} is wrong url base`);
        return '';
    }
};
const ContentWidget = React.forwardRef((props, ref) => {
    const { domain, className, ...rest } = props;
    const cx = useStyles(modules_3d0bf2ca);
    const [theme] = useTheme();
    const url = generateUrl(theme, domain);
    return (React.createElement("div", { ref: ref, className: cx('wrapper', className), ...rest },
        React.createElement("iframe", { src: url, width: 573, height: 350 })));
});

export { ContentWidget };
//# sourceMappingURL=ContentWidget.js.map
